// TODO Покрыть тестами
/* istanbul ignore file */

import type { RefObject } from 'react';
import type { ICollectorData } from '@alfa-bank/site-registry-tools/collector-data';

import type { TFocusExcludeAttributes } from '../models';

const topPadding = 50;

export const NUMBER_LENGTH = 11;

/**
 * Получить элемент
 * @param target HTML-элемент
 * @param allowedElements Список имён в нижнем регистре разрешенных элементов по клику на которые происходит скролл и фокус на поле
 * @returns Разрешенный элемент или `null`, если таковой не найден
 */
const getAllowedElement = (target?: Element, allowedElements: string[] = ['a', 'button']) => {
    if (!target) return null;

    /** Если click был по кнопке (<button/>) или ссылке (<a/>) */
    if (allowedElements.includes(target.nodeName.toLowerCase())) return target;

    /** Если нет, ищем ближайшего родителя, селектор которого кнопка (<button/>) или ссылка (<a/>) */
    return target.closest(allowedElements.join(','));
};
/**
 *
 * @param textContent текстовый контент элемента
 * @param list массив строк с разрешенным текстовым контентом
 * @returns true | false - входит ли textContent в list
 */
const isAttributeValueInList = (textContent: string, list: string[]) =>
    list.some((value: string) =>
        value.trim().toLowerCase().includes(textContent.trim().toLowerCase())
    );

export const getButtonsListener =
    (
        focusCaptions: string[],
        focusExcludeAttributes: TFocusExcludeAttributes,
        ref: RefObject<HTMLInputElement>,
        name = 'phone',
        operatingSystemName?: ICollectorData['operatingSystemName']
    ) =>
    // eslint-disable-next-line sonarjs/cognitive-complexity
    (e: MouseEvent) => {
        const element = getAllowedElement(e.target as Element);
        if (!element) return;

        /** Текстовый контент для focusCaptions */
        const { textContent } = element;
        if (!textContent) return;
        let hash = '';

        /** Проверяем, текст в "кнопке" совпадает с указаными вариантами в focusCaptions */
        if (isAttributeValueInList(textContent, focusCaptions)) {
            /** Проверяем, что у элемента все указаные в focusExcludeAttributes (key) атрибуты
             *  совпадают с указаными в focusExcludeAttributes(value) значениями
             */
            const exclude = Object.entries(focusExcludeAttributes).some(([attrKey, attrRegExp]) => {
                const matcher = new RegExp(attrRegExp);

                if (attrKey === 'href') {
                    // если клик произошел по кнопке, то пытаемся найти родителя - ссылку,
                    // необходимо для кейсов, когда кнопка обернута в ссылку
                    const linkElement = getAllowedElement(element, ['a']);
                    const href = linkElement?.getAttribute(attrKey);
                    if (typeof href === 'string' && !matcher.test(href)) {
                        hash = href;
                    }

                    return Boolean(href && matcher.test(href));
                }

                const attr = element.getAttribute(attrKey);

                return Boolean(attr && matcher.test(attr));
            });

            if (exclude) return;

            const isIOS = Boolean(operatingSystemName && operatingSystemName === 'iOS');

            /** Работающий скролл с фокусом в WebKit (так же проставляет якорь в URL) */
            /* istanbul ignore if */
            if (isIOS && document && window && ref?.current) {
                e.preventDefault();
                const scrollTop = (
                    document.querySelector(`[name="${name}"]`) as HTMLInputElement
                ).getBoundingClientRect().top;

                /** ссылка для добавления якоря в URL */
                const link = document.createElement('a');

                /** Условия, что бы избежать повторных манипуляция с dom элементом если hash уже есть в url */
                const isHash = hash && location.hash !== hash;
                if (isHash) {
                    link.style.position = 'absolute';
                    link.style.left = '-9999px';
                    link.href = hash;
                    document.body.append(link);
                }

                /** TODO PhoneField для корректной работы требудет Form
                 * подумать, можно искать через .closest ближайший родительский form тэг и скролить до него
                 * а не до самого поля с отступом сверху topPadding
                 */
                if (scrollTop > 0) {
                    /** scrollBy когда скролим вниз */
                    window.scrollBy({
                        top: scrollTop - topPadding,
                        behavior: 'smooth',
                    });
                } else {
                    /** scrollTo когда скролим вверх */
                    window.scrollTo({
                        top: window.pageYOffset + scrollTop - topPadding,
                        behavior: 'smooth',
                    });
                }

                if (isHash) {
                    /** Иимитируем клик по ссылке для доавления якроя в URl
                     *  Если делать через код (location.replace) проскроливает нужный элемент
                     */
                    link.dispatchEvent(new MouseEvent('click'));
                }
                /** Ставим фокус в нужное поле без скрола до него */
                ref?.current.focus({ preventScroll: true });
                /** Удаляем елемент ссылки */
                link.remove();

                return;
            }
            // Судя по всему, ButtonV2 (а именно, CoreButton) перехватывает фокус и блюрит инпут. Нулевой таймаут решает проблему.
            setTimeout(() => ref?.current?.focus(), 0);
        }
    };
